import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import {
  Ch_generateAttestationGuardianDocumentInput,
  useChGenerateLegalGuardianDocumentMutation as useChGenerateLegalGuardianDocumentMutationType,
} from "@/modules/patients/detail/legal-guardian-attestation/ch/services/__generated__/useChGenerateLegalGuardianDocumentMutation.graphql"
import { usePatientParam } from "@/modules/patients/hooks/usePatientParam"

const generateDocumentMutation = graphql`
  mutation useChGenerateLegalGuardianDocumentMutation($input: Ch_generateAttestationGuardianDocumentInput!) {
    ch_generateAttestationGuardianDocument(input: $input) {
      ch_AttestationGuardian {
        fileId
        ...chLegalGuardianAttestationFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useChGenerateLegalGuardianDocumentMutationType>, "variables"> & {
  params: Pick<Ch_generateAttestationGuardianDocumentInput, "id">
}

const useChGenerateLegalGuardianDocumentMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChGenerateLegalGuardianDocumentMutationType>(
    generateDocumentMutation,
    params,
  )
  const patientById = usePatientParam()

  const commitHandler = useCallback(
    (config: Config) => {
      commit({
        variables: {
          input: { patientId: patientById, id: config.params.id },
        },
        ...config,
      })
    },
    [commit, patientById],
  )

  return [commitHandler, isFlight] as const
}

export { useChGenerateLegalGuardianDocumentMutation }
